var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import cls from 'classnames';
import { Icon, TouchFeedback } from 'rcm-mobile';
import './style/index.scss';
// 偷懒了～～，extra API被移除，改用children,配合表单的children查询
/**
 * @author tongxiaokang
 * @version 0.0.1
 *
 * 实现了 [TouchFeedback](#/Components/TouchFeedback) 组件的所有API。
 */
export default class ListItem extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleClick = (e) => {
            const { onClick, disabled } = this.props;
            if (!disabled && onClick) {
                onClick(e);
            }
        };
        this.state = { rotate: Icon.getRotate(props.arrow) };
    }
    render() {
        const _a = this.props, { className, activeStyle, activeClassName, wrap, disabled, title, children, thumb, arrow, onClick, prefixCls } = _a, restProps = __rest(_a, ["className", "activeStyle", "activeClassName", "wrap", "disabled", "title", "children", "thumb", "arrow", "onClick", "prefixCls"]);
        return (<TouchFeedback disabled={disabled} activeStyle={activeStyle} activeClassName={activeClassName}>
        <div {...restProps} onClick={this.handleClick} className={cls(`${prefixCls}`, className, { 'x-disabled': disabled })}>
          {thumb ? (<div className={`${prefixCls}-thumb`}>
              {typeof thumb === 'string' ? <img className={`${prefixCls}-thumb-img`} src={thumb}/> : thumb}
            </div>) : null}

          <div className={cls(`${prefixCls}-line`, { [`${prefixCls}-line-wrap`]: wrap })}>
            {title
            ? <div className={`${prefixCls}-line-content`}>
                {title}
              </div>
            : null}

            {children !== undefined && <div className={`${prefixCls}-line-extra`}>{children}</div>}

            {arrow && (<div className={`${prefixCls}-line-arrow`}>
                <Icon rotate={this.state.rotate} className="x-icon-arrow-left"/>
              </div>)}
          </div>
        </div>
      </TouchFeedback>);
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.arrow !== prevState.arrow) {
            return { rotate: Icon.getRotate(nextProps.arrow) };
        }
        return null;
    }
    /**
     * 辅助说明
     * */
    static Brief(props) {
        const prefixCls = ListItem.defaultProps.prefixCls;
        if (!props.children)
            return null;
        return <div className={`${prefixCls}-brief`}>{props.children}</div>;
    }
}
ListItem.defaultProps = {
    wrap: false,
    arrow: '',
    disabled: false,
    prefixCls: 'x-list-item',
    activeClassName: 'x-active'
};
